import "./../App.css";

interface LinkCardProps {
  message: string;
}

export default function LinkCard({ message }: LinkCardProps) {
  return (
    <div className="card rounded-lg w-full flex gap-10 2xsw:gap-2 py-4">
      <div className="border rounded-lg bg-white border-gray-400">
        <p className="text-xl smw:text-sm p-4 2xsw:p-2 2xsw:text-xs text-justify">
          {message}
        </p>
      </div>
      <img
        className="border rounded-full self-center max-w-48 h-48 smw:max-w-24 smw:h-24"
        src={process.env.PUBLIC_URL + "/images/face_picture.jpg"}
        alt="Caleb Sipper Face Shot"
      />
    </div>
  );
}
